import React, { useEffect, useState } from 'react';
import { Download, ArrowRight } from 'lucide-react';
import { apiGet } from '../utils/api';

const FreeResourcesBar = () => {
  const [resumeUrl, setResumeUrl] = useState('');
  const [interviewUrl, setInterviewUrl] = useState('');

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const resources = await apiGet('/api/resources');
        const resume = resources.find(r => (r.title || '').toLowerCase().includes('resume'));
        const interview = resources.find(r => (r.title || '').toLowerCase().includes('interview'));
        if (active) {
          setResumeUrl(resume?.fileUrl || '');
          setInterviewUrl(interview?.fileUrl || '');
        }
      } catch (e) {
        // ignore, links will fallback to /resources
      }
    })();
    return () => { active = false; };
  }, []);

  return (
    <div className="bg-[#F5F7FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-col md:flex-row items-center gap-3 md:gap-4 justify-between">
        <div className="text-[#1E293B] text-sm font-medium flex items-center gap-2">
          <span className="font-semibold">Free Career Resources</span>
          <span className="hidden sm:inline text-[#64748B] font-normal">— Download our ATS-ready resume template and interview checklist</span>
        </div>
        <div className="flex items-center gap-3">
          <a
            href={resumeUrl || '/resources'}
            target={resumeUrl ? '_blank' : undefined}
            rel={resumeUrl ? 'noopener noreferrer' : undefined}
            className="inline-flex items-center gap-2 bg-white hover:bg-[#F8FAFC] text-[#3B82F6] font-semibold px-4 py-2 rounded-full border-2 border-[#3B82F6] text-sm shadow-sm transition-all duration-200 hover:shadow-md"
          >
            <Download className="w-4 h-4" /> Resume Template
          </a>
          <a
            href={interviewUrl || '/resources'}
            target={interviewUrl ? '_blank' : undefined}
            rel={interviewUrl ? 'noopener noreferrer' : undefined}
            className="inline-flex items-center gap-2 bg-white hover:bg-[#EFF6FF] text-[#3B82F6] font-semibold px-4 py-2 rounded-full border border-[#CBD5E1] text-sm shadow-sm transition-all duration-200 hover:shadow-md"
          >
            <Download className="w-4 h-4" /> Interview Checklist
          </a>
          <a 
            href="/resources" 
            className="hidden md:inline-flex items-center gap-1 text-[#3B82F6] hover:text-[#2563EB] font-semibold text-sm transition-colors"
          >
            See all <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default FreeResourcesBar;
